import axios from "axios";

export const uploadToCloudinary = async (file) => {
  if (!file) {
    throw new Error("No file selected.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

  try {
    const { data } = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/image/upload`,
      formData
    );
    return data; // contains secure_url, public_id, etc.
  } catch (error) {
    console.error("Cloudinary upload error:", error);
    throw error;
  }
};
